define.alias("ember-drag-sort/components/drag-sort-item", "media/components/drag-sort-item");